// extracted by mini-css-extract-plugin
export default {"boxInfo":"Main_boxInfo__VLYyx","card_tools":"Main_card_tools__m+Aey"};